import { render, staticRenderFns } from "./login3.vue?vue&type=template&id=07f0fa74&scoped=true"
import script from "./login3.vue?vue&type=script&lang=js"
export * from "./login3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f0fa74",
  null
  
)

export default component.exports